import { Sparkles, UserCheck } from 'lucide-react'
import type { MissingEssential } from '@/hooks/useInstructorThemeStats'

interface EssentialsGapListProps {
  essentials: MissingEssential[]
}

const COLUMNS = 4

function intoColumns<T>(items: T[], columns: number): T[][] {
  const perColumn = Math.ceil(items.length / columns)
  return Array.from({ length: columns }, (_, i) => items.slice(i * perColumn, i * perColumn + perColumn)).filter(
    (column) => column.length > 0,
  )
}

export function EssentialsGapList({ essentials }: EssentialsGapListProps) {
  const columns = intoColumns(essentials, COLUMNS)

  return (
    <div className="grid gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">
      {columns.map((column, columnIndex) => (
        <ul key={columnIndex} className="flex flex-col gap-4">
          {column.map((track) => (
            <li key={`${track.artist_name}-${track.track_name}`} className="flex items-start gap-2">
              <span className="w-7 shrink-0 pt-px text-right text-xs tabular-nums text-muted-foreground">
                {track.rank}
              </span>
              <div className="flex min-w-0 flex-1 flex-col gap-1">
                <span className="truncate text-sm font-medium">{track.track_name}</span>
                <span className="truncate text-xs text-muted-foreground">{track.artist_name}</span>
                <span
                  className={
                    track.artist_already_played
                      ? 'flex w-fit items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-[11px] text-muted-foreground'
                      : 'flex w-fit items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 text-[11px] font-medium text-primary'
                  }
                >
                  {track.artist_already_played ? (
                    <>
                      <UserCheck className="size-3" />
                      Knows the artist
                    </>
                  ) : (
                    <>
                      <Sparkles className="size-3" />
                      New artist
                    </>
                  )}
                </span>
              </div>
            </li>
          ))}
        </ul>
      ))}
    </div>
  )
}
